---
title: Reverb
description: "A reverb device: a decay, a pre-delay, a damping and a mix, a panel that draws the tail with a handle, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-reverb" />

Puts the sound in a room. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="reverb" kind="device" />

## Controls

<DeviceControls device="reverb">
<Control id="decay">How long the tail takes to fall by 60 dB. Drag the handle at the end of the tail to set it.</Control>
<Control id="preDelayMs">The time between the sound and the start of the tail.</Control>
<Control id="dampingHz">Closes the highs of the tail, as soft walls do.</Control>
<Control id="mix">The balance of the room and the dry signal.</Control>
</DeviceControls>

## Panel

The panel draws the level of the tail falling in dB, from the end of the pre-delay to -60 dB. `reverbDecay(state)` is the curve it draws, and `reverbImpulse(sampleRate, state)` makes the impulse response of the room.

<DeviceUsage name="reverb" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The room is a convolver fed an impulse response made from the decay and the damping. A convolver cannot change its impulse without a click, so the engine has two and cross-fades: a new room is built in the idle one, at most every 120 ms while a control moves.
